module.exports = ".row{\r\n    padding:10px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.form-group label{\r\n    color: #0000ff;\r\n    width: 99%;\r\n    font-size: 18px;\r\n    font-weight: normal\r\n}\r\n\r\n.border-box{\r\n    border: 1px solid black;\r\n    padding: 5px 15px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/staff-criminal-proceedings/form2-view-criminal-proceeding/form2-view-criminal-proceeding.component.css
// module id = ./src/app/pages/functions/staff-criminal-proceedings/form2-view-criminal-proceeding/form2-view-criminal-proceeding.component.css
// module chunks = main